import React from 'react';
// import { useNavigate } from 'react-router-dom';
import {  useSelector } from "react-redux";
// import { portalActions } from "../../store/portal-slice";
// import { getLocalStore, setLocalStore } from "helpers/localStoreSrv";
// import whitelabelConfig from "@whitelabel-config";
import { useUiState } from "helpers/useUiState";
import { useApi } from "helpers/useApi";
// import api from "helpers/api";
export const useMemberActivityListSrv = () => {
    //const { isAppLoading } = useUiState();
   // const dispatch = useDispatch();
    const { api } = useApi();
    const portalSessionMeta = useSelector((state: any) => state.portal.micrositeSession);
    console.log("portalSessionMeta", portalSessionMeta)

    const httpGetMemberActivities = () => {
        console.log("portalSessionMeta ww", portalSessionMeta)
        return api.get('/api/survey')

    }
    // const getSurveyData =(survey:any)=>{
    //     return api.get('/assets/json/surveydata.json')
    // }
    const mergeSurveyJson = async (surveyDetails: any) => {
        const surveyData = await fetch('../' + surveyDetails.SurveyUrl)
        const surveyResponse = await surveyData.json()
        return surveyResponse
    }



    return { httpGetMemberActivities, mergeSurveyJson }
}